export type AnalyticsParams = Record<string, string | number | boolean | undefined>;
const measurementId = 'G-DK8FR2RYZ8';
const allowed = new Set(['membership_level', 'access_mode', 'book_id', 'book_title', 'menu_id', 'menu_name', 'parent_menu_id', 'source', 'outcome', 'reason', 'position_seconds', 'duration_seconds', 'position_percent', 'listening_seconds', 'audio_seconds', 'playback_rate', 'milestone', 'elapsed_ms', 'enabled', 'timer', 'feature']);
const metaEvents = new Set(['selfie_requested', 'selfie_created', 'audiobook_play_click', 'audiobook_started', 'audiobook_upgrade_click']);

export function analyticsPage(path: string): string {
  const page = path.split('/')[1];
  return ['chat', 'chats', 'saved', 'price', 'audiobooks', 'setting', 'login', 'signup', 'support'].includes(page) ? page : 'home';
}

export function membershipLevel(plan?: string): string {
  switch (String(plan || '').toLowerCase()) {
    case 'premium': return 'premium';
    case 'plus': case 'patron': return 'patron';
    case 'basic': case 'free': case 'subscriber': return 'subscriber';
    case 'guest': return 'guest';
    default: return 'unknown';
  }
}

// Analytics must never block the feature or receive prompts, identities, signed URLs or raw errors.
export function track(name: string, params: AnalyticsParams = {}) {
  try {
    if (!['bookishboyfriend.com', 'www.bookishboyfriend.com'].includes(window.location.hostname)) return;
    if (navigator.doNotTrack === '1' || (navigator as any).globalPrivacyControl === true) return;
    const clean: AnalyticsParams = {};
    for (const [key, value] of Object.entries(params)) {
      if (!allowed.has(key) || value === undefined) continue;
      if (typeof value === 'number' && Number.isFinite(value)) clean[key] = Math.round(value * 100) / 100;
      else if (typeof value === 'boolean') clean[key] = value;
      else if (typeof value === 'string') clean[key] = value.slice(0, 100);
    }
    const host = window as any;
    const event = `bb_${name}`;
    // Nested payload avoids stale book/menu parameters persisting into later GTM events.
    try { (host.dataLayer = host.dataLayer || []).push({ event, bb: clean, bb_delivery: 'direct' }); } catch {}
    try {
      host.gtag?.('event', event, { ...clean, send_to: measurementId,
        page_location: `${window.location.origin}/${analyticsPage(window.location.pathname) === 'home' ? '' : analyticsPage(window.location.pathname)}`,
        page_referrer: '', page_title: 'Bookish Boyfriend', transport_type: 'beacon',
        allow_google_signals: false, allow_ad_personalization_signals: false });
    } catch {}
    // Reading choices can be sensitive: no book, genre, character, or listening details to advertising.
    if (metaEvents.has(name)) {
      try { host.fbq?.('trackCustom', event, { membership_level: clean.membership_level || 'unknown' }); } catch {}
    }
  } catch {}
}

export function imageFailure(error: any): string {
  if (error?.image_limit || error?.monthly_limit || error?.monthly_limit_with_bonus || error?.exhausted_current_subscription) return 'quota';
  if (error?.premium_only || error?.pg_only || error?.upgrade_needed || error?.plus_trail_ended) return 'membership';
  if (error?.image_moderated) return 'provider_rejected';
  return 'request_failed';
}
